var DOMAnimations = {
    
  /**
  * SlideUp
  *
  * @param {HTMLElement} element
  * @param {Number} duration
  * @returns {Promise<boolean>}
  */
  slideUp: function (element, duration = 500) {

      return new Promise(function (resolve, reject) {

          element.style.height = element.offsetHeight + 'px';
          element.style.transitionProperty = `height, margin, padding`;
          element.style.transitionDuration = duration + 'ms';
          element.offsetHeight;
          element.style.overflow = 'hidden';
          element.style.height = 0;
          element.style.paddingTop = 0;
          element.style.paddingBottom = 0;
          element.style.marginTop = 0;
          element.style.marginBottom = 0;
          window.setTimeout(function () {
              element.style.display = 'none';
              element.style.removeProperty('height');
              element.style.removeProperty('padding-top');
              element.style.removeProperty('padding-bottom');
              element.style.removeProperty('margin-top');
              element.style.removeProperty('margin-bottom');
              element.style.removeProperty('overflow');
              element.style.removeProperty('transition-duration');
              element.style.removeProperty('transition-property');
              resolve(false);
          }, duration)
      })
  },

  /**
  * SlideDown
  *
  * @param {HTMLElement} element
  * @param {Number} duration
  * @returns {Promise<boolean>}
  */
  slideDown: function (element, duration = 500) {

      return new Promise(function (resolve, reject) {

          element.style.removeProperty('display');
          let display = window.getComputedStyle(element).display;

          if (display === 'none') 
              display = 'block';

          element.style.display = display;
          let height = element.offsetHeight;
          element.style.overflow = 'hidden';
          element.style.height = 0;
          element.style.paddingTop = 0;
          element.style.paddingBottom = 0;
          element.style.marginTop = 0;
          element.style.marginBottom = 0;
          element.offsetHeight;
          element.style.transitionProperty = `height, margin, padding`;
          element.style.transitionDuration = duration + 'ms';
          element.style.height = height + 'px';
          element.style.removeProperty('padding-top');
          element.style.removeProperty('padding-bottom');
          element.style.removeProperty('margin-top');
          element.style.removeProperty('margin-bottom');
          window.setTimeout(function () {
              element.style.removeProperty('height');
              element.style.removeProperty('overflow');
              element.style.removeProperty('transition-duration');
              element.style.removeProperty('transition-property');
          }, duration)
      })
  },

  /**
  * SlideToggle
  *
  * @param {HTMLElement} element
  * @param {Number} duration
  * @returns {Promise<boolean>}
  */
  slideToggle: function (element, duration = 500) {

      if (window.getComputedStyle(element).display === 'none') {

          return this.slideDown(element, duration);

      } else {

          return this.slideUp(element, duration);
      }
  }
}

function initAccordion(){
  // get all `accordion` blocks
  const accordions = document.querySelectorAll('.accordion');
  var transitionend = true;
  accordions.forEach(accordion => {
    // get all `panel` elements
    const panels = accordion.querySelectorAll('.accordion__panel');
    panels.forEach(panel => {
      // get `title` element
      const title = panel.querySelector('.accordion__title');
      let panel_content = panel.querySelector('.accordion__content');
      panel_content.addEventListener('transitionstart',() =>{
        transitionend = false;
      });
      panel_content.addEventListener('webkitTransitionStart',() =>{
        transitionend = false;
      });
      panel_content.addEventListener('transitioncancel',() =>{
        transitionend = true;
      });
      panel_content.addEventListener('webkitTransitionEnd',() =>{
        transitionend = true;
      });
      // toggle 'active' modifier on title click
      title.addEventListener('click', () => {
        if (!transitionend) {
          return;
        }
        //let panel_content = panel.querySelector('.accordion__content');
        if (!panel.classList.contains('accordion__panel--active')) {
          panel.classList.add('accordion__panel--active');
          DOMAnimations.slideDown(panel_content);
        }else{
          panel.classList.remove('accordion__panel--active');
          DOMAnimations.slideUp(panel_content);
        }
      });
    })
  })
}

function scrollToTarget(link, duration) {
  link.forEach(trigger => {
    trigger.onclick = function(e) {
        e.preventDefault();
        let hash = this.getAttribute('href');
        let target = document.querySelector(hash);
        let headerOffset = 200;
        let elementPosition = target.offsetTop;
        let offsetPosition = elementPosition - headerOffset;
        let drawer = target.querySelector('.accordion__content');

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
        
        if(!drawer.classList.contains('accordion__panel--active')){ 
          const parent = drawer.parentElement;
          parent.classList.add('accordion__panel--active');
        };
        DOMAnimations.slideDown(drawer, duration);
    };
  });
}

function viewportWidth () {
  if (window.innerWidth) return window.innerWidth;
  var
  doc = document,
  html = doc && doc.documentElement,
  body = doc && (doc.body || doc.getElementsByTagName("body")[0]),
  getWidth = function (elm) {
    if (!elm) return 0;
    var setOverflow = function (style, value) {
      var oldValue = style.overflow;
      style.overflow = value;
      return oldValue || "";
    }, style = elm.style, oldValue = setOverflow(style, "hidden"), width = elm.clientWidth || 0;
    setOverflow(style, oldValue);
    return width;
  };
  return Math.max(
    getWidth(html),
    getWidth(body)
  );
}
//https://github.com/m-gagne/limit.js
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last,
      deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date,
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function selectDropdown(){
  let selects = document.querySelectorAll('.dropdown-select');
  selects.forEach( select => {
    let select_label = select.querySelector('.dropdown-select__label') ? select.querySelector('.dropdown-select__label').innerText : '';
    let select_options = select.querySelectorAll('.dropdown-select__list li');
    select_options.forEach(option => {
      if( option.innerText == select_label ){
        option.classList.add('is-active');
        return;
      }
    })
    select.addEventListener('click', (e) => {
      select.classList.toggle('is-expanded');
      if (!select.classList.contains('is-expanded')){
      }else{

      }
    })
  })
}

function wrapTable(options) {
  const rte_tables = document.querySelectorAll('.rte table');
  rte_tables.forEach(function(table) {
    let wrapper = document.createElement('div');
    wrapper.classList.add('rte-table');
    wrapper.appendChild(table.cloneNode(true));
    table.replaceWith(wrapper);
  });
}

function toggleSidebarMenu(){
  const togglebtn = document.querySelectorAll('.js-menu__sidebar--toggle');
  const menuSidebar = document.querySelector('.menu-sidebar');
  togglebtn.forEach(btn => {
    const toggleMenu = document.querySelector('.menu-sidebar__inner');
    const menuitem_active = menuSidebar.querySelector('.menu-sidebar__active');
    if ( menuitem_active ) {
      btn.querySelector('span').innerHTML = menuitem_active.innerHTML;
    }else{
      const page_title = document.querySelector('#MainContent .content h1');
      if (page_title) {
        btn.querySelector('span').innerHTML = page_title.innerHTML;
      }
    }
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!btn.classList.contains('is-open')) {
        menuSidebar.classList.add('is-open');
        btn.classList.add('is-open');
        toggleMenu.classList.add('menu-sidebar__open');
        DOMAnimations.slideDown(toggleMenu);
      }else{
        menuSidebar.classList.remove('is-open');
        btn.classList.remove('is-open');
        toggleMenu.classList.remove('menu-sidebar__open');
        DOMAnimations.slideUp(toggleMenu);
      }
    })
  });
}

function qtySelectors(){
  const $body = document.querySelector('body');
  // Qty selector has a minimum of 1 on the product page
  // and 0 in the cart (determined on qty click)
  let qtyMin = 1,
      qtyMax = -1;
  const qtyadjuster = document.querySelectorAll('.js--qty-adjuster');
  qtyadjuster.forEach(adj => {
    adj.removeEventListener('click',(e)=>{});
  });
  qtyadjuster.forEach(adj => {
    adj.addEventListener('click', (e)=> {
      e.preventDefault();

      let el = adj,
      //id = el.data('id'),
      qtySelector = el.parentNode.querySelector('.js--qty-num'),
      qty = parseInt(qtySelector.value.replace(/\D/g, ''));
      // Make sure we have a valid integer
      if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a number!
      } else {
          // Not a number. Default to 1.
          qty = 1;
      }
      if ( $body.classList.contains('template-cart') || el.closest('.cart-item') ) {
          qtyMin = 0;
      }
      qtyMax = qtySelector.hasAttribute('max') ? parseInt( qtySelector.getAttribute('max') ) : -1;
      // Add or subtract from the current quantity
      if (el.classList.contains('js--add')) {
          qty = qty + 1;
      } else {
          qty = qty - 1;
          if (qty <= qtyMin) qty = qtyMin;
      }
      // Update the input's number
      if( qtyMax >= 0 && qty > qtyMax ){
        qty = qtyMax;
      }
      if( qtySelector.value != qty ){
        qtySelector.value = qty;
        var t = setTimeout(function(){
          clearTimeout(t);
          triggerEvent(qtySelector, 'change');
        }, 300);
      }
    })
  });

  const qtyInputs = document.querySelectorAll('.js--qty-num');
  qtyInputs.forEach(qty => {
    qty.addEventListener('change', (e)=> {
      e.preventDefault();
      let value = e.target.value,
      old_value = qty.hasAttribute('data-value') ? parseInt( qty.getAttribute('data-value') ) : e.target.value,
      qtyMax = qty.hasAttribute('max') ? parseInt( qty.getAttribute('max') ) : -1;
      if( qtyMax >= 0 && value > qtyMax ){
        qty.value = qtyMax;
      }
      if ( old_value != qty.value && ($body.classList.contains('template-cart') || qty.closest('.cart-item')) ) {
        qty.closest('form.cart-form').submit();
      }
    })
  });
  
  function triggerEvent(el, type) {
    // IE9+ and other modern browsers
    if ('createEvent' in document) {
        var e = document.createEvent('HTMLEvents');
        e.initEvent(type, false, true);
        el.dispatchEvent(e);
    } else {
        // IE8
        var e = document.createEventObject();
        e.eventType = type;
        el.fireEvent('on' + e.eventType, e);
    }
  }
}

function deviceType(){
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
  }
  else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return "mobile";
  }
  return "desktop";
};